import VueCookie from "vue-cookie";

export default {
  products: [],
  hasProduct(productId){
    let products = this.products
    for(let product in products) {
      product = products[product]
      if (product.id === productId) {
        return true
      }
    }
    return false
  },
  retrieve() {
    let products = Core.Session.getValue('SessionCartProducts')
    if (products) {
      products = JSON.parse(products)
      this.products = products
    }
  },
  add2(product, distinct) {
    if (product.quantity > 0) {
      let index = Core.Array.findIndexByKey(this.products, 'id', product.id)
      if (index === false||distinct) {
        let newProduct = Core.Array.newObject(product)
        newProduct.data = {}
        this.products.push(newProduct)
      } else {
        this.products[index].quantity = parseInt(product.quantity)
      }
      Core.Session.setValue('SessionCartProducts', JSON.stringify(this.products))
    } else {
      this.remove(product.id)
    }
  },
  add(product, append, distinct) {
    if (append === undefined) {
      append = true
    }
    if (distinct === undefined) {
      distinct = false
    }
    if (distinct) {
      let newProduct = Core.Array.newObject(product)
      newProduct.data = {}
      this.products.push(newProduct)
    } else {
      let index = Core.Array.findIndexByKey(this.products, 'id', product.id)
      if (index === false) {
        let newProduct = Core.Array.newObject(product)
        newProduct.data = {}
        this.products.push(newProduct)
      } else  {
        if (append) {
          this.products[index].quantity = parseInt(this.products[index].quantity) +  parseInt(product.quantity)
        } else {
          this.products[index].quantity = 1
        }
      }
    }
    Core.Session.setValue('SessionCartProducts', JSON.stringify(this.products))
  },
  addPromoCode(productId, promoCode) {
    for(let productIndex in this.products) {
      let product = this.products[productIndex]
      if (product.id === productId) {
        this.products[productIndex].data = {
          promoCode: promoCode
        }
      }
    }
    Core.Session.setValue('SessionCartProducts', JSON.stringify(this.products))
  },
  remove(productId) {
    let index = Core.Array.findIndexByKey(this.products, 'id', productId)
    if (index !== false) {
       this.products.splice(index, 1)
    }
    Core.Session.setValue('SessionCartProducts', JSON.stringify(this.products))
  },
  getQuantity(productId) {
    let index = Core.Array.findIndexByKey(this.products, 'id', productId)
    if (index !== false) {
      return this.products[index].quantity
    }
    return 0
  },
  empty() {
    this.products = []
    Core.Session.setValue('SessionCartProducts', JSON.stringify(this.products))
  }
}
